<template>
    <div>
        <form novalidate>
            <div class="md-layout">
                <div class="md-layout-item md-small-size-100">
                    <div class="md-layout-item md-small-size-100">
                        <canvas id="canvas-signature"></canvas>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { IVuelidateComponentOptions } from '@/services/entities/vuelidate.entity';
import SignaturePad from 'signature_pad';

@Component({
    mixins: [validationMixin],
    validations: {
        form: {
            signature: {},
        },
    },
} as IVuelidateComponentOptions)
export default class SignatureView extends Vue {
    @Prop()
    signatureImage: string;
    @Prop()
    sending: boolean;

    signaturePad: SignaturePad | null = null;

    form: any;

    constructor() {
        super();
    }

    mounted() {
        this.signaturePad = new SignaturePad(document.querySelector('#canvas-signature'));

        // Restore existing signature if available
        if (this.signatureImage) {
            this.signaturePad.fromDataURL(this.signatureImage);
        }

        // Emit every time user finishes drawing
        this.signaturePad.onEnd = () => {
            this.emitSignature();
        };
    }

    @Emit('signature-updated')
    emitSignature() {
        if (this.signaturePad) {
            return this.signaturePad.toDataURL();
        }
        return null;
    }
}
</script>

<style scoped>
canvas {
    border: solid;
}
</style>
